<template>
  <div class="container">
    <div class="page-title">
      <i class="el-icon-back" @click="back"  style="cursor:pointer"></i>
      <span style="padding-left: 8px;">{{role == 1 ? '发布公告': '查看公告'}}</span>
    </div>
    <div class="content" >
      <div class="content-top" v-if="role == 1">
        <div class="date-box">
          <div class="label" style="width: 160px;">请选择时间</div>
          <el-date-picker
            :disabled="role != 1"
            v-model="value2"
            start-placeholder="时间"
            align="right">
          </el-date-picker>
        </div>
        <div class="date-box" style="padding-left: 12px;margin-right: 20px;">
          <div class="label" style="width: 65px;">标题</div>
          <el-input
            :disabled="role != 1"
            style=" width:500px"
            placeholder="请输入内容"
            v-model="title"
            clearable>
          </el-input>
        </div>
      </div>
      <div class="content-bottom">
        <quill-editor
          v-if="test"
          :disabled="role != 1"
          class="ql-editor"
          v-model="content"
          ref="myQuillEditor"
          :options="editorOption"
          @blur="onEditorBlur($event)"
          @focus="onEditorFocus($event)"
          @change="onEditorChange($event)">
        </quill-editor>
        <div style="margin-top: 20px;" v-if="role == 1">
          <el-button size="mid" type="primary" :disabled="!content"  @click="submit(1)">保存</el-button>
          <el-button size="mid" type="primary" style="margin-left: 20px;" :disabled="!content"  @click="submit(2)">保存并发布</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { quillEditor } from 'vue-quill-editor' // 调用编辑器
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  // import Quill from 'quill' // 引入编辑器
  // 自定义字体大小
  // const Size = Quill.import('attributors/style/size')
  // Size.whitelist = ['10px', '12px', '16px', '18px', '20px', '30px', '32px']
  // Quill.register(Size, true)
  //
  // // 自定义字体类型
  // var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'sans-serif']
  // var Font = Quill.import('formats/font')
  // Font.whitelist = fonts
  // Quill.register(Font, true)
  export default {
    data () {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        value2: '',
        detail: {},  //详情
        dialogVisible: false,
        editorOption: {
          placeholder: '请在这里输入',
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
              // ['blockquote', 'code-block'], // 引用，代码块
              [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
              [{ list: 'ordered' }, { list: 'bullet' }], // 列表
              [{ script: 'sub' }, { script: 'super' }], // 上下标
              [{ indent: '-1' }, { indent: '+1' }], // 缩进
              [{ direction: 'rtl' }], // 文本方向
              [{ size: ["small", false, "large", "huge"] }], // 字体大小
              [{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
              [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
              [{ font: [false, 'SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial'] }], // 字体种类
              [{ align: [] }], // 对齐方式
              ['clean'], // 清除字体样式
              ['image'] // 链接、图片、视频
              // ['link', 'image', 'video'] // 链接、图片、视频
            ]
          }
        },
        content: '',
        title: '',
        noticeId: '',
        role: 1,
        test: false
      };
    },
    components: {
      quillEditor
    },
    activated () {
      this.value2 = '';
      this.content = '';
      this.title = '';
      this.role = window.sessionStorage.role;
      if(this.role != '1'){
        this.editorOption.modules.toolbar = null
      }
      this.test = true
      this.noticeId = this.$route.query.noticeId;
      if (this.noticeId) {
        this.findNotice();
      }
    },
    methods: {
      // 失去焦点事件
      onEditorBlur (quill) {
        console.log('editor blur!', quill)
      },
      // 获得焦点事件
      onEditorFocus (quill) {
        console.log('editor focus!', quill)
      },
      // 准备富文本编辑器
      onEditorReady (quill) {
        console.log('editor ready!', quill)
      },
      // 内容改变事件
      onEditorChange ({ quill, html, text }) {
        console.log('editor change!', quill, html, text)
        this.content = html
      },
      submit (status) {
        const data = {
          content: this.content,
          status,
          title: this.title,
          startTime: this.value2
        }
        if (this.noticeId) {
          data.noticeId = this.noticeId;
        }
        this.$http.post("/plan/uploadNotice", data, {
          headers: {
            token: window.sessionStorage.manageToken
          }
        })
          .then(res => {
            console.log('res====', res)
            if (res.data.code === 'ok') {
              console.log('resdatadata====', res.data.data)
              const message = status === 1 ? '保存成功' : '发布成功';
              this.$message.success(message);
              setTimeout(()=>{
                this.back();
              },500)
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      findNotice () {
        this.$http.post(`/plan/findNotice/${this.noticeId}`, {}, {
          headers: {
            token: window.sessionStorage.manageToken
          }
        })
          .then(res => {
            console.log('res====', res)
            if (res.data.code === 'ok') {
              console.log('resdatadata====', res.data.data)
              const data = res.data.data || {};
              this.title = data.title;
              this.content = data.content
              this.value2 = data.startTime;
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      back(){
        this.$router.go(-1);
      },
    },
  }
</script>
<style lang="less" scoped>
  /deep/ .red-row {
    color: red;
  }
  .container {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
  }

  .content {
    display: flex;
    flex-direction: column;
    overflow: auto;
    flex: 1;
    margin-top: 10px;

    .content-top {
      display: flex;
      align-items: center;
      /*margin-top: 10px;*/
      margin-bottom: 10px;
      /*position: fixed;*/
      /*justify-content: flex-start;*/
      /*flex-direction: column;*/

      .first-line {
        display: flex;
        justify-content: flex-start;
      }

      .label {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        /*text-align: right;*/

        color: #000000;
        padding-right: 10px;
      }

      .date-box {
        display: flex;
        align-content: center;
        padding-left: 12px;
      }

      /*.first-line {*/
      /*  display: flex;*/
      /*  justify-content: flex-start;*/
      /*  margin-bottom: 20px;*/
      /*}*/
      /*.label {*/
      /*  display: flex;*/
      /*  align-items: center;*/
      /*  justify-content: flex-end;*/
      /*  !*text-align: right;*!*/
      /*  font-size: 16px;*/
      /*  color: #000000;*/
      /*  padding-right: 10px;*/
      /*}*/
      /*.date-box {*/
      /*  display: flex;*/
      /*  align-items: center;*/
      /*  padding-left: 12px;*/
      /*}*/
      /*.third-line {*/
      /*  margin-left: 20px;*/
      /*  margin-top: 10px;*/
      /*}*/
    }

    .content-bottom {
      overflow: auto;
      margin-bottom: 10px;
      flex: 1;
    }

    .ql-editor {
      line-height: normal !important;
      height: 500px;
      overflow: auto;
    }

    /*.ql-snow .ql-tooltip[data-mode="link"]::before {*/
    /*  content: "请输入链接地址:";*/
    /*}*/
    /*.ql-snow .ql-tooltip.ql-editing a.ql-action::after {*/
    /*  border-right: 0px;*/
    /*  content: "保存";*/
    /*  padding-right: 0px;*/
    /*}*/

    /*.ql-snow .ql-tooltip[data-mode="video"]::before {*/
    /*  content: "请输入视频地址:";*/
    /*}*/

    /*.ql-snow .ql-picker.ql-size .ql-picker-label::before,*/
    /*.ql-snow .ql-picker.ql-size .ql-picker-item::before {*/
    /*  content: "14px";*/
    /*}*/
    /*.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,*/
    /*.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {*/
    /*  content: "10px";*/
    /*}*/
    /*.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,*/
    /*.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {*/
    /*  content: "18px";*/
    /*}*/
    /*.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,*/
    /*.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {*/
    /*  content: "32px";*/
    /*}*/

    /*.ql-snow .ql-picker.ql-header .ql-picker-label::before,*/
    /*.ql-snow .ql-picker.ql-header .ql-picker-item::before {*/
    /*  content: "文本";*/
    /*}*/
    /*.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,*/
    /*.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {*/
    /*  content: "标题1";*/
    /*}*/
    /*.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,*/
    /*.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {*/
    /*  content: "标题2";*/
    /*}*/
    /*.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,*/
    /*.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {*/
    /*  content: "标题3";*/
    /*}*/
    /*.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,*/
    /*.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {*/
    /*  content: "标题4";*/
    /*}*/
    /*.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,*/
    /*.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {*/
    /*  content: "标题5";*/
    /*}*/
    /*.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,*/
    /*.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {*/
    /*  content: "标题6";*/
    /*}*/

    /*.ql-snow .ql-picker.ql-font .ql-picker-label::before,*/
    /*.ql-snow .ql-picker.ql-font .ql-picker-item::before {*/
    /*  content: "标准字体";*/
    /*}*/
    /*.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,*/
    /*.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {*/
    /*  content: "衬线字体";*/
    /*}*/
    /*.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,*/
    /*.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {*/
    /*  content: "等宽字体";*/
    /*}*/
    // 给文本内容加高度，滚动条
    /*.quill-editor /deep/ .ql-container {*/
    /*  min-height: 220px;*/
    /*}*/

    /*.ql-container {*/
    /*  min-height: 230px;*/
    /*}*/

    /*/deep/*/
    /*  .ql-snow .ql-tooltip [data-mode="link"]::before {*/
    /*    content: "请输入链接地址:";*/
    /*    left: 0;*/
    /*  }*/

    /*  .ql-snow .ql-tooltip.ql-editing {*/
    /*    left: 0 !important;*/
    /*  }*/

    /*  .ql-snow .ql-tooltip {*/
    /*    left: 0 !important;*/
    /*  }*/

    /*  .ql-snow .ql-editor {*/
    /*    max-height: 300px;*/
    /*  }*/

    /*  .ql-snow .ql-tooltip.ql-editing a.ql-action::after {*/
    /*    border-right: 0px;*/
    /*    content: "保存";*/
    /*    padding-right: 0px;*/
    /*  }*/

    /*  .ql-snow .ql-tooltip[data-mode="video"]::before {*/
    /*    content: "请输入视频地址:";*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-size .ql-picker-label::before, .ql-snow .ql-picker.ql-size .ql-picker-item::before {*/
    /*    content: "14px" !important;*/
    /*    font-size: 14px;*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="10px"]::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="10px"]::before {*/
    /*    content: "10px" !important;*/
    /*    font-size: 10px;*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="12px"]::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="12px"]::before {*/
    /*    content: "12px" !important;*/
    /*    font-size: 12px;*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16px"]::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {*/
    /*    content: "16px" !important;*/
    /*    font-size: 16px;*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {*/
    /*    content: "18px" !important;*/
    /*    font-size: 18px;*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="20px"]::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {*/
    /*    content: "20px" !important;*/
    /*    font-size: 20px;*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="30px"]::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="30px"]::before {*/
    /*    content: "30px" !important;*/
    /*    font-size: 30px;*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="32px"]::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {*/
    /*    content: "32px" !important;*/
    /*    font-size: 32px;*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-header .ql-picker-label::before, .ql-snow .ql-picker.ql-header .ql-picker-item::before {*/
    /*    content: "文本" !important;*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {*/
    /*    content: "标题1" !important;*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {*/
    /*    content: "标题2" !important;*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {*/
    /*    content: "标题3" !important;*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {*/
    /*    content: "标题4" !important;*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {*/
    /*    content: "标题5" !important;*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {*/
    /*    content: "标题6" !important;*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-font .ql-picker-label::before, .ql-snow .ql-picker.ql-font .ql-picker-item::before {*/
    /*    content: "标准字体" !important;*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {*/
    /*    content: "衬线字体" !important;*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {*/
    /*    content: "等宽字体" !important;*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="SimSun"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="SimSun"]::before {*/
    /*    content: "宋体" !important;*/
    /*    font-family: "SimSun";*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="SimHei"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="SimHei"]::before {*/
    /*    content: "黑体" !important;*/
    /*    font-family: "SimHei";*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Microsoft-YaHei"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Microsoft-YaHei"]::before {*/
    /*    content: "微软雅黑" !important;*/
    /*    font-family: "Microsoft YaHei";*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="KaiTi"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="KaiTi"]::before {*/
    /*    content: "楷体" !important;*/
    /*    font-family: "KaiTi";*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="FangSong"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="FangSong"]::before {*/
    /*    content: "仿宋" !important;*/
    /*    font-family: "FangSong";*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Arial"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Arial"]::before {*/
    /*    content: "Arial" !important;*/
    /*    font-family: "Arial";*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Times-New-Roman"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Times-New-Roman"]::before {*/
    /*    content: "Times New Roman" !important;*/
    /*    font-family: "Times New Roman";*/
    /*  }*/

    /*  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="sans-serif"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="sans-serif"]::before {*/
    /*    content: "sans-serif" !important;*/
    /*    font-family: "sans-serif";*/
    /*  }*/

    /*  .ql-font-SimSun {*/
    /*    font-family: "SimSun";*/
    /*  }*/

    /*  .ql-font-SimHei {*/
    /*    font-family: "SimHei";*/
    /*  }*/

    /*  .ql-font-Microsoft-YaHei {*/
    /*    font-family: "Microsoft YaHei";*/
    /*  }*/

    /*  .ql-font-KaiTi {*/
    /*    font-family: "KaiTi";*/
    /*  }*/

    /*  .ql-font-FangSong {*/
    /*    font-family: "FangSong";*/
    /*  }*/

    /*  .ql-font-Arial {*/
    /*    font-family: "Arial";*/
    /*  }*/

    /*  .ql-font-Times-New-Roman {*/
    /*    font-family: "Times New Roman";*/
    /*  }*/

    /*  .ql-font-sans-serif {*/
    /*    font-family: "sans-serif";*/
    /*  }*/

    /*  !*.ql-snow.ql-toolbar .ql-formats .ql-revoke {*!*/
    /*  !*  background-image: url("../../../../assets/images/icons8-rotate-left-18.png");*!*/
    /*  !*  width: 20px;*!*/
    /*  !*  height: 20px;*!*/
    /*  !*  filter: grayscale(100%);*!*/
    /*  !*  opacity: 1;*!*/
    /*  !*}*!*/

    /*  !*.ql-snow.ql-toolbar .ql-formats .ql-revoke:hover {*!*/
    /*  !*  background-image: url("../../../../assets/images/icons8-rotate-left-18.png");*!*/
    /*  !*  width: 20px;*!*/
    /*  !*  height: 20px;*!*/
    /*  !*  filter: none;*!*/
    /*  !*  opacity: 0.9;*!*/
    /*  !*}*!*/

    /*  img {*/
    /*    filter: grayscale(100%);*/
    /*    opacity: 1;*/
    /*  }*/

    /*  img:hover {*/
    /*    filter: none;*/
    /*    opacity: 0.9;*/
    /*  }*/

    /*  !*加上height和滚动属性就可以，滚动条样式是系统默认样式，可能不同*!*/
    /*  .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {*/
    /*    border-color: #ccc;*/
    /*    height: 125px;*/
    /*    overflow: auto;*/
    /*  }*/

    /*!*加上height和滚动属性就可以，滚动条样式是系统默认样式，可能不同*!*/
    /*.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {*/
    /*  border-color: #ccc;*/
    /*  height: 125px;*/
    /*  overflow: auto;*/
    /*}*/
  }
</style>
